import React from "react";
import { map } from "lodash";
import { Typography } from "@material-ui/core";
import StateContainer from "components/layouts/default-state-container";
import AppointmentListItem from "./appointment-list-item";

const AppointmentList = ({
  stateProps,
  appointments,
}) => {
  if (stateProps === undefined) {
    return <AppointmentListComponent appointments={appointments} />;
  }

  return <AppointmentListWithState {...stateProps} appointments={appointments} />;
};

const AppointmentListComponent = ({
  appointments,
}) => (
  <>
    {map(appointments, (referralAppointment, index) => {
      const { appointment, appointmentReferrals } = referralAppointment;

      return (
        <AppointmentListItem
          key={appointment.id}
          type="appointment"
          item={appointment}
          appointmentReferrals={appointmentReferrals}
          isFirst={index === 0 || index === "0"}
        />
      );
    })}
  </>
);

export const AppointmentListWithState = ({
  title,
  isEmpty,
  isError,
  isLoading,
  emptyTitle = "No Recorded Appointments",
  appointments,
}) => (
  <StateContainer loading={isLoading} error={isError} empty={isEmpty} emptyTitle={emptyTitle}>
    {title && <Typography className="px-16" gutterBottom>{title}</Typography>}
    <AppointmentListComponent appointments={appointments} />
  </StateContainer>
);

export default AppointmentList;
